import api from './api';

// In-browser editing of Word, Excel and PowerPoint files (ONLYOFFICE). Backend: routers/editor.py
export const OPENABLE = ['doc', 'docx', 'docm', 'dot', 'dotx', 'odt', 'ott', 'rtf', 'txt', 'md', 'epub', 'htm', 'html',
  'xls', 'xlsx', 'xlsm', 'xlt', 'xltx', 'ods', 'ots', 'csv', 'ppt', 'pptx', 'pptm', 'pot', 'potx', 'odp', 'otp', 'pdf'];
export const EDITABLE = ['docx', 'docm', 'dotx', 'odt', 'rtf', 'txt', 'xlsx', 'xlsm', 'xltx', 'ods', 'csv', 'pptx', 'pptm', 'potx', 'odp'];

export const extOf = (name) => {
  const m = /\.([A-Za-z0-9]+)$/.exec(name || '');
  return m ? m[1].toLowerCase() : '';
};
export const canOpenInEditor = (doc) => OPENABLE.includes(extOf(doc?.filename));
export const canEditInEditor = (doc) => EDITABLE.includes(extOf(doc?.filename));

export const editorAPI = {
  status: () => api.get('/api/editor/status'),
  config: (id, mode = 'edit') => api.get(`/api/editor/${id}/config`, { params: { mode } }),
  create: (data) => api.post('/api/editor/new', data),
  versions: (id) => api.get(`/api/editor/${id}/versions`),
  downloadVersion: (id, n, filename) =>
    api.get(`/api/editor/${id}/versions/${n}`, { responseType: 'blob' }).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || `version-${n}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    }),
};
